import type { ComponentProps, ReactNode } from "react"
import { Badge as BadgeBase } from "@/v2-ui/badge/base/BadgeBase"
import cn from "@/v2-ui/utils/utils.cn"
import Skeleton from "@/v2-ui/skeleton"

export type BadgeProps = ComponentProps<typeof BadgeBase> & {
  isSkeleton?: boolean
  renderAfter?: () => ReactNode
  renderBefore?: () => ReactNode
}

function Badge(props: BadgeProps) {
  const {
    isSkeleton,
    renderAfter,
    renderBefore,
    className,
    children,
    ...badgeBaseProps
  } = props

  if (isSkeleton) {
    return (
      <Skeleton className={cn("ui-badge ui-badge__skeleton", className)}>
        {/* @Note: to get the same height as a badge */}
        &nbsp;
      </Skeleton>
    )
  }
  return (
    <BadgeBase className={className} {...badgeBaseProps}>
      {renderBefore && renderBefore()}
      {children}
      {renderAfter && renderAfter()}
    </BadgeBase>
  )
}

export default Badge
